import React, { useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { debounce } from '@thd-olt-functional/utils';

import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/image';
import { Button } from '@thd-olt-component-react/button';

import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import { MessagingContainer } from '../promo-call-to-action/subcomponents/MessagingContainer/MessagingContainer';
import { InfoContainer } from '../promo-call-to-action/subcomponents/InfoContainer/InfoContainer';
import { PromoAddItemsToCart } from './subcomponents/AddItemsToCart/PromoAddItemsToCart';
import { PromoHeaderMessaging } from './subcomponents/PromoHeaderMessaging/PromoHeaderMessaging';
import './PromoHeader.scss';

export const PromoHeader = () => {
  const { channel } = useContext(ExperienceContext);
  const { isMsb, isBmsm } = usePromoModel();
  const { setIsDrawerOpen } = usePromoPresentation();
  const { freeItemInCart, bogoSelectedProduct } = usePromoCart();
  const [containerExpanded, setContainerExpanded] = useState(true);
  const [innerHeight, setInnerHeight] = useState(window?.innerHeight);

  const showContainerExpansionControls = (freeItemInCart || bogoSelectedProduct)
    && (channel === 'mobile' || innerHeight < 700);

  useEffect(() => {
    if (!showContainerExpansionControls) setContainerExpanded(true);
  }, [showContainerExpansionControls, setContainerExpanded]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (window) {
      const resetHeight = debounce(50, () => setInnerHeight(window.innerHeight));
      window.addEventListener('resize', resetHeight);
      return () => window.removeEventListener('resize', resetHeight);
    }
  }, [setInnerHeight]);

  const headerClasses = classNames('promo-header', {
    'promo-header--tiered': isMsb || isBmsm,
  });

  return (
    <div className={headerClasses} data-testid="promo-header">
      <div className="promo-header__messaging">
        <MessagingContainer isInPromoDrawer />
        <div
          data-testid="promo-icon-close"
          className="promo-icon promo-icon-close"
          aria-label="Close Promotion Drawer"
          onClick={() => setIsDrawerOpen(false)}
          tabIndex={0}
          role="button"
        />
      </div>
      {containerExpanded && (
        <>
          <InfoContainer isInPromoDrawer />
          <PromoHeaderMessaging />
        </>
      )}
      <PromoAddItemsToCart />
      {showContainerExpansionControls && (
        <div className="promo-header__show-more-less u__bold">
          <Button
            onClick={() => setContainerExpanded(!containerExpanded)}
            inline
            cta
          >
            {containerExpanded ? 'Show Less' : 'Show More'}
            &nbsp;&nbsp;
            <Image
              asset="caret-orange.svg"
              alt=""
              className={containerExpanded ? 'u__rotate-270' : 'u__rotate-90'}
            />
          </Button>
        </div>
      )}
    </div>
  );
};

PromoHeader.displayName = 'PromoHeader';
